var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useGetConsumerInfo } from '../DynamicValues/hook';
import { useSelector } from 'react-redux';
import { getTeamId } from '../../selectors/portal_selector';
import { getSelectedTeamAccount } from '../../selectors/uiSelector';
import { readCookie } from '../../utils/cookie_helper';
export var useGetConsumerAndTeamInfo = function () {
    var _a = useGetConsumerInfo(), consumerId = _a.consumerId, isGuest = _a.isGuest;
    var teamId = useSelector(getTeamId) || '';
    var teamAccountId = useSelector(getSelectedTeamAccount) || '';
    var cookiesBasedContext = {
        deviceId: readCookie('dd_device_id') || '',
    };
    return __assign({ consumer_id: consumerId, isGuest: isGuest,
        teamId: teamId,
        teamAccountId: teamAccountId }, cookiesBasedContext);
};
